const MicroEvent	= () => {
  const events = {}

	const bind = (event, fct) => {
		events[event] = events[event]	|| [];
		events[event].push(fct);
	};

	const unbind = (event, fct) => {
		if( event in events === false  )	return;
		events[event].splice(events[event].indexOf(fct), 1);
	};
	const trigger = (event, props) => {
		if( event in events === false  )	return;
		for(var i = 0; i < events[event].length; i++){
			events[event][i](props);
		}
	}

  return {bind, unbind, trigger}
};

// export in common js
export default MicroEvent();
